export const BASE_URL:string = `\${BASE_TAB_DOMAIN}`;